<template>
    <div class="" id="Details">
        <!-- <mt-header fixed title="">
      <router-link to="/" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
      <mt-button slot="right">
          <img src="static/image/share@2x.png" alt="">
          <span>分享</span>
      </mt-button>
    </mt-header> -->
        <mt-swipe :auto="4000">
            <mt-swipe-item v-for="(item,key) in resData.images" v-bind:key="key">
                <img v-lazy="item.imgPath" />
            </mt-swipe-item>
        </mt-swipe>
        <div class="title">
            <h1>{{resData.carModelName}}</h1>
            <span>{{resData.price}}<em>万</em></span>
            <!-- <em>新车价{{resData.newCarPrice ||0 }}万</em> -->
            <!-- <div class="earn float-right">
                <img src="static/image/earn@2x.png" alt="">
                <span>赚10马力</span>
            </div> -->
        </div>
        <div class="line-5"></div>
        <div class="stages">
            <ul>
                <li>
                    <span>1成首付</span>
                    <span>{{resData.price*0.1|number}}万</span>
                </li>
                <li>
                    <span>月供</span>
                    <span>{{resData.price*0.9/36*10000|money}}元</span>
                </li>
                <li>
                    <span>期数</span>
                    <span>36期</span>
                </li>
                <div class="clearfix"></div>
            </ul>
            <div>
                <span>多种分期购车方案 立即咨询</span>
                <img src="static/image/next@2x.png" alt="">
            </div>
        </div>
        <div class="line-5"></div>
        <div class="configure">
            <h1>车辆档案</h1>
            <hr>
            <ul>
                <li>
                    <span>{{GET_DICT(10,resData.firstLicenseDate)}}</span>
                    <span>驱动方式</span>
                </li>
                <li>
                    <span>{{GET_DICT(8,resData.carOilSyste)}}</span>
                    <span>燃料形式</span>
                </li>
                <li>
                    <span>{{resData.carPlateCityId||' '}}</span>
                    <span>车辆所在地</span>
                </li>
                <li>
                    <span>{{GET_DICT(5,resData.emissionsStandards)}}</span>
                    <span>排放标准</span>
                </li>
                <li>
                    <span>{{GET_DICT(9,resData.carGearboxType)}}</span>
                    <!-- <span>{{carGearboxType[resData.carGearboxType]}}</span> -->
                    <span>变速箱</span>
                </li>
                <li>
                    <span>{{resData.outputVolumne}}</span>
                    <span>排放量</span>
                </li>
                <div class="clearfix"></div>
            </ul>
            <hr>
            <div>
                <router-link :to="'/Configure/'+resData.id">
                    <span>查看详细参数配置</span>
                    <img src="static/image/next@2x.png" alt="">
                </router-link>
            </div>
        </div>
        <div class="line-5"></div>
        <div class="four" v-show="resData.type==1">
            <img src="static/image/four.png" alt="">
        </div>
        <div class="used_car" v-show="resData.type==2">
            <img src="static/image/certificate@2x.png" alt="">
        </div>
        <div class="line-5"></div>
        <div class="four" v-show="resData.type==1">
            <img src="static/image/notes.png" alt="">
        </div>
        <div class="used_car" v-show="resData.type==2">
            <img src="static/image/carbuy@2x.png" alt="">
        </div>
        <div class="line-5"></div>
        <div class="img">
            <img v-for="(item,key) in resData.images" v-bind:key="key" v-lazy="item.imgPath" />
        </div>
        <div class="line-59"></div>
        <div class="footer">
            <ul>
                <li>
                    <img src="static/image/keep@2x.png" alt="">
                    <span @click="onCollection" class="c1">收藏</span>
                </li>
                <li>
                    <img src="static/image/service@2x.png" alt="">
                    <span class="">客服</span>
                </li>
                <li>
                    <span class="" @click="onShowReserve">立即预约</span>
                </li>
            </ul>
        </div>
        <mt-popup v-model="popupVisible" position="bottom">
            <div class="ordered">
                <h1>立即预约</h1>
                <span>我们会在第一时间与您联系</span>
                <hr>
                <ul>
                    <li>
                        <span>预约门店</span>
                        <em>{{resData.storeId}}</em>
                    </li>
                    <li>
                        <span>手机号</span>
                        <input placeholder="请输入手机号" v-model="reserve.phone" type="text">
                    </li>
                </ul>
                <button @click="onReserve" :disabled="loading">{{loading?'预约中':'立即预约'}}</button>
            </div>
        </mt-popup>
        <div class="success" v-show="reserveSuccessModal">
            <div class="success_box">
                <img class="close" @click="reserveSuccessModal=false" src="static/image/close@2x.png" alt="">
                <h1>预约成功</h1>
                <span>我们将尽快与您联系</span>
                <!-- <div class="next">
                    <span>立即查看</span>
                    <img src="static/image/next@2x.png" alt="">
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
/**
 * carModelName - 标题（车辆名称）
 * mileage - 公里数
 * newCarPrice - 新车价
 * price - 车价
 * type - 车辆类型  1（新车） 2（二手车）
 * carOilSystemLabel - 燃气形式/供油系统
 * carDriverTypeLabel - 驱动方式
 * carPlateCityId - 车辆所在城市
 * emissionsStandardsLabel - 排放标准
 * carGearboxTypeLabel - 变速箱
 * outputVolumne - 排放量
 * firstLicenseDate - 初次上牌时间
 * carColor - 车系颜色
 * interiorColor - 内饰颜色
 * vinCode - VIN码
 * carBrandName - 车辆品牌
 * carSeriesName - 车系名称
 * carImages - 图片集合
 * airIntakeMethodLabel - 进气方式
 */
import {
    Swipe,
    SwipeItem,
    Header,
    Cell,
    DatetimePicker,
    Indicator,
    Toast
} from "mint-ui";
import {
    API_GET,
    API_POST,
    getLocation,
    getToken,
    API_POST_TOKEN,
    clearToken,
    GET_DICT
} from "@/apiConfig";
import Vue from "vue";
export default {
    name: "Details",
    data() {
        return {
            resData: {},
            carGearboxType: {
                0: `不限`,
                1: `MT(手动)`,
                2: `AT(自动)`,
                3: `AMT(机械式)`,
                4: `4CVT(无级)`,
                5: `DSG(双离合)`
            }, //  变速箱 0不限 1MT(手动) 2AT(自动) 3AMT(机械式) 4CVT(无级) 5DSG(双离合)
            reserve: {},
            loading: false,
            popupVisible: false, // 申请预约modal
            reserveSuccessModal: false, //预约成功modal
            GET_DICT: function(){

            }
        };
    },
    mounted() {
        window.scroll(0, 0);
        this.fetchData();
        this.GET_DICT = GET_DICT;
    },
    methods: {
        goback: function() {
            window.history.go(-1);
        },

        fetchData: function() {
            let body = {
                carId: this.$route.params.id
            };
            if (body.carId != null) {
                this.loading = true;
                API_POST("/car/getCarInfoDetail", body).then(res => {
                    this.loading = false;
                    if (res.status == 0) {
                        this.resData = res.data;
                    } else {
                        Toast({
                            message: res.msg
                        });
                    }
                });
            }
        },
        onShowReserve: function(sortFlag) {
            /**
             * 点击弹出立即预约弹出层
             */
            let token = getToken();
            if (!token || token == "undefined") {
                this.$router.push("/login");
                return;
            }
            this.popupVisible = true;
        },
        onReserve: function(sortFlag) {
            /**
             * 申请预约
             */

            let body = {
                carId: this.$route.params.id
            };
            body.phone = this.reserve.phone ? this.reserve.phone.trim() : "";
            if (/^1[34578]\d{9}$/.test(body.phone)) {
                this.loading = true;
                API_POST_TOKEN("/carBuyClue/reserve", body).then(res => {
                    // Indicator.close();
                    if (res.status == 0) {
                        this.popupVisible = false;
                        this.reserveSuccessModal = true;
                    } else if (res.status == 600) {
                        clearToken()
                        this.$router.push("/login");
                        Toast(`登录信息过期，请重新登录`);
                    } else {
                        Toast(res.msg);
                    }
                    this.loading = false;
                });
            } else {
                Toast({
                    message: `请输入正确的手机号`
                    // duration: -1,
                });
            }
        },
        onCollection: function(sortFlag) {
            /**
             * 收藏车辆
             */

            let body = {
                carId: this.$route.params.id
            };

            API_POST_TOKEN("/car/collection", body).then(res => {
                // Indicator.close();
                if (res.status == 0) {
                    Toast(`车辆收藏成功`);
                    // this.popupVisible = false;
                    // this.reserveSuccessModal = true;
                } else if (res.status == 600) {
                    clearToken()
                    this.$router.push("/login");
                    Toast(`登录信息过期，请重新登录`);
                } else {
                    Toast(res.msg);
                }
                this.loading = false;
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
    color: #ffffff;
}
.mint-header {
    background-color: rgba(0, 0, 0, 0) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/DetailsImg.vue